<template>
    <section class="sectionDiv"
             id="technologies">
        <div class="container"
             id="techTop">
            <div class="row d-flex justify-content-between">
                <div data-aos-easing="ease-in-out"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-2 col-sm-2 col-xs-2"
                     style="margin: 0 auto">
                    <i style="color: #f0db4f; "
                       class="fab fa-js fa-5x"></i>
                </div>
                <div data-aos-easing="ease-in-out"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-2 col-sm-2 col-xs-2"
                     style="margin: 0 auto">
                    <i style="color: #3fb27f; "
                       class="fab fa-vuejs fa-5x"></i>
                </div>
                <div data-aos-easing="ease-in-out"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-2 col-sm-2 col-xs-2"
                     style="margin: 0 auto">
                    <i style="color: #61DBFB; "
                       class="fab fa-react fa-5x"></i>
                </div>
                <div data-aos-easing="ease-in-out"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-2 col-sm-2 col-xs-2"
                     style="margin: 0 auto">
                    <i style="color: #7fc728; "
                       class="fab fa-node fa-5x"></i>
                </div>

                <!-- <div class="col-2" style="height: 100px">
            <i
              style="color: #f08d03"
              class="fas fa-database fa-10x mx-auto"
            ></i>
            <p style="margin: 8px; color: white">
              FileMaker<br />Mongo<br />MySQL
            </p>
          </div> -->
            </div>
            <hr />
            <div class="row">
                <div data-aos-easing="ease-in-out"
                     data-aos-delay="600"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-4 col-xs-2 mx-auto">
                    <h1 class="techH1">
                        Technologies
                    </h1>
                    <p class="technologyHeaders"
                       style="color: white; text-align: left; max-width: 500px">
                        While I have used a myriad of technologies in my developer career,
                        I have found myself mainly using <span style="color: #F0DB4F">JavaScript</span>, <span
                              style="color: #3FB27F">Vue</span> and <span style="color: #7FC728">Node</span>. I
                        also have experience with:<br><br>
                    <ul>
                        <li>Express</li>
                        <li>Bootstrap</li>
                        <li>FileMaker Pro</li>
                        <li>React</li>
                        <li>jQuery</li>
                        <li>MySQL</li>
                        <li>MongoDB</li>


                    </ul>
                    </p>
                </div>
                <br />
                <hr id="techLine" />
                <div data-aos-easing="ease-in-out"
                     data-aos-delay="800"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-4 col-xs-2 mx-auto">
                    <h1 class='techH1'>
                        Tools
                    </h1>
                    <p style="color: white; text-align: left; max-width: 500px">
                        While developing, I use quite a few tools to get help get the job done. Outside of frameworks,
                        libraries,
                        etc, here few of my most utilized tools are:
                        <br><br>
                    <ul>
                        <li>Git/GitHub</li>
                        <li>Postman</li>
                        <li>VS Code</li>
                        <li>NPM</li>
                        <li>Bash Shell</li>
                        <li>ChatGPT (ftw)</li>

                    </ul>
                    </p>
                </div>

            </div>

            <a data-scroll
               href="#portfolio"
               class=""
               data-aos-easing="ease-in-out"
               data-aos-duration="500"
               data-aos="fade-in"
               style="color: white; margin-top: 0px; position: relative; top: -20px;"
               data-aos-delay="1500"><button style="border-radius: 0px; min-width: 30%"
                        class="btn portfolioButton hvr-underline-from-left">
                    View My Work
                </button></a>
        </div>
        <!-- <video autoplay muted loop class="hero-video">
        asda
		<source src="images/banner/hero-video.mp4" type="video/mp4">
	</video> -->
    </section>
</template>
  
<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import AOS from "aos";
// import "aos/dist/aos.css";

export default {
    props: {
        testProp: String
    },

    created() {
        // AOS.init();
        document.title = "Alex Gignilliat";

    },

    data() {
        return {

            introHeader: "",
            colorVanta: "rgb(24, 154, 243)",
            backgroundColorVanta: "red",
            options: {
                mouseControls: true,
                touchControls: true,
                minHeight: 500.00,
                minWidth: 200.00,
                scale: 1.00,
                scaleMobile: 1.00
            },
            methods: {
                headerChange: function () {
                    this.introHeader = "hehrhsdjkfhs";
                },
            },

        };
    },

    name: "Technologies",



};
</script>
  
